import {
  ROUTE_GOAL_SETTING,
  ROUTE_PRINCIPLE_SPIRIT,
  ROUTE_PRINCIPLE_MINDSET,
  ROUTE_PRINCIPLE_EXERCISE,
  ROUTE_PRINCIPLE_NUTRITION,
  ROUTE_TEST
} from 'routes/routes';

export default [
  { text: 'Goal Setting', route: ROUTE_GOAL_SETTING },
  {
    text: 'Core 4 Principles',
    subNavs: [
      { text: 'Spirit', route: ROUTE_PRINCIPLE_SPIRIT },
      { text: 'Mindset', route: ROUTE_PRINCIPLE_MINDSET },
      { text: 'Exercise', route: ROUTE_PRINCIPLE_EXERCISE },
      { text: 'Nutrition', route: ROUTE_PRINCIPLE_NUTRITION }
    ]
  },
  { text: 'Exercise Components', route: '#' },
  { text: 'Blog', route: '#' },
  { text: 'Test', route: ROUTE_TEST } // TOOD: remove
];
